
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/politique-confidentialite",
      function () {
        return require("private-next-pages/politique-confidentialite.tsx");
      }
    ]);
  